export default __webpack_public_path__ + "static/media/story-SLIDE_6.449910a3.jpg";